export default __webpack_public_path__ + "static/media/Brainstormen rond een thema vanuit de sdg’s.6aa92589.zip";